import React from 'react';
import * as S from './toggle.styles';

interface IToggleProps {
    children?: React.ReactNode;
    enabled?: boolean;
    onChange?: (value: boolean) => void;
}

export const Toggle: React.FunctionComponent<IToggleProps> = (props: IToggleProps): React.ReactElement => {
    const { enabled, onChange } = props;

    const handleClick = (): void => {
        onChange && onChange(!enabled);
    };

    return (
        <S.Toggle enabled={!!enabled} onClick={handleClick}>
            <S.Knob />
        </S.Toggle>
    );
};
